import React, { useMemo } from 'react';

import { documentTextOutline, searchOutline } from 'ionicons/icons';

import EmptyContent from 'components/EmptyContent';
import ErrorContent from 'components/ErrorContent';
import { useScreenState } from 'components/Screen';
import { SEARCH_QUERY, TABLE_SETTINGS } from 'scenes/FinancePage/constants';
import { useFinance } from 'scenes/FinancePage/data';

import List from './components/List';
import ListSkeleton from './components/ListSkeleton';
import './index.css';

export default () => {
  const {
    data,
    isRefetching,
    isLoading,
    isError,
    error,
    isSuccess,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useFinance();
  const screenState = useScreenState();
  const emptyIcon = useMemo(() => {
    return screenState[TABLE_SETTINGS][SEARCH_QUERY]
      ? searchOutline
      : documentTextOutline;
  }, [screenState[TABLE_SETTINGS][SEARCH_QUERY]]);

  const isEmpty = useMemo(() => {
    return !data || data?.pages?.[0]?.count === 0;
  }, [data]);

  const onIonInfinite = async (ev: any) => {
    await fetchNextPage();
    ev.target.complete();
  };

  const isRefetchingFirstPage = isRefetching && !isFetchingNextPage;

  const renderComponent = useMemo(() => {
    switch (true) {
      case isError: //Loaded with error response
        return <ErrorContent icon={documentTextOutline} error={error} />;
      case isLoading:
        return <ListSkeleton />; //No loaded
      case isEmpty:
        return <EmptyContent icon={emptyIcon} withBorder={false} />; //Loaded with empty response
      case isSuccess: //Loaded with normal response
        return (
          <List
            isRefetching={isRefetchingFirstPage}
            data={data}
            onIonInfinite={onIonInfinite}
            isInfiniteDisabled={!hasNextPage}
          />
        );

      default:
        return null;
    }
  }, [
    isLoading,
    isRefetchingFirstPage,
    isEmpty,
    isSuccess,
    isError,
    data,
    error,
    fetchNextPage,
  ]);

  return <div className={'finance-list'}>{renderComponent}</div>;
};
